<div class="tooltip tooltip-with-label"
      #tooltip="matTooltip"
      [matTooltip]=tooltipText
      [matTooltipPosition]=tooltipPosition>
              <mat-icon svgIcon="help_outline"
                        [class.tooltip--left]="labelPosition === 'right'"
                        class="_common-icon--red-help"></mat-icon>
              <span class="tooltip-with-label__label">{{label}}</span>
</div>
